var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from 'app/core/api/api.js';
import { fetchDashboardData } from './dashboards';
import { createDashboardWidget } from './dashboardWidgets';
import { updateDataFromCollection } from './utils';
const initialState = {
    loading: true,
    widgetLoadingId: null,
    data: [],
    error: null,
};
const removeDuplicates = (data, key) => {
    return [...new Map(data.map((x) => [key(x), x])).values()];
};
export const fetchAllWidgets = createAsyncThunk('widgets/fetchAll', (_1, _a) => __awaiter(void 0, [_1, _a], void 0, function* (_, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.widgets.fetchAll();
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const createWidget = createAsyncThunk('widgets/create', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ widget, dashboardId, isSupervisor }, { fulfillWithValue, rejectWithValue, dispatch }) {
    try {
        const res = yield api.widgets.create(widget);
        const dashboardWidget = {
            dashboard: dashboardId,
            widget: res.id,
            isSupervisor,
        };
        dispatch(createDashboardWidget(dashboardWidget));
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const updateWidget = createAsyncThunk('widgets/update', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ updatedWidget, refetchData }, { fulfillWithValue, rejectWithValue, dispatch, getState }) {
    try {
        const res = yield api.widgets.update(updatedWidget);
        if (refetchData) {
            const dashboardWidgets = getState().dashboardWidgets.data;
            const rel_dashboardWidgetInst = dashboardWidgets.find((dw) => dw.widget === updatedWidget.id);
            yield dispatch(fetchDashboardData(rel_dashboardWidgetInst.dashboard));
        }
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const updateWidgets = createAsyncThunk('widgets/update/collection', (updatedWidgets_1, _a) => __awaiter(void 0, [updatedWidgets_1, _a], void 0, function* (updatedWidgets, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.widgets.collection.update(updatedWidgets);
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const deleteWidget = createAsyncThunk('widgets/delete', (widgetId_1, _a) => __awaiter(void 0, [widgetId_1, _a], void 0, function* (widgetId, { fulfillWithValue, rejectWithValue }) {
    try {
        yield api.widgets.delete(widgetId);
        return fulfillWithValue(widgetId);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const { actions, reducer } = createSlice({
    name: 'widgets',
    initialState,
    reducers: {
        setWidgetsFromDashboards: (state, { payload }) => {
            const t = [...state.data, ...payload];
            const newData = removeDuplicates(t, (it) => it.id);
            state.data = newData;
        },
    },
    extraReducers: (builder) => {
        // CREATE WIDGET
        builder.addCase(createWidget.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(createWidget.fulfilled, (state, { payload }) => {
            const newData = [...state.data, payload];
            state.data = newData;
            state.loading = true;
        });
        builder.addCase(createWidget.rejected, (state, { payload }) => {
            state.error = payload;
            state.loading = false;
        });
        // UPDATE WIDGET
        builder.addCase(updateWidget.pending, (state, action) => {
            const widgetId = action.meta.arg.updatedWidget.id;
            state.widgetLoadingId = widgetId;
        });
        builder.addCase(updateWidget.fulfilled, (state, { payload }) => {
            const newData = state.data.map((widget) => {
                if (widget.id === payload.id) {
                    return payload;
                }
                return widget;
            });
            state.data = newData;
            state.widgetLoadingId = null;
        });
        builder.addCase(updateWidget.rejected, (state, { payload }) => {
            state.error = payload;
            state.widgetLoadingId = null;
        });
        // UPDATE WIDGETS COLLECTION
        builder.addCase(updateWidgets.pending, (state, action) => {
            // const widgetId = action.meta.arg.updateWidgets.id
            // state.widgetLoadingId = widgetId
        });
        builder.addCase(updateWidgets.fulfilled, (state, { payload }) => {
            const newData = updateDataFromCollection(state.data, payload);
            state.data = newData;
            state.widgetLoadingId = null;
        });
        builder.addCase(updateWidgets.rejected, (state, { payload }) => {
            state.error = payload;
            state.widgetLoadingId = null;
        });
        // DELETE WIDGET
        builder.addCase(deleteWidget.pending, (state, action) => { });
        builder.addCase(deleteWidget.fulfilled, (state, { payload }) => {
            state.data = state.data.filter((widget) => widget.id !== payload);
        });
        builder.addCase(deleteWidget.rejected, (state, { payload }) => { });
    },
});
export const { setWidgetsFromDashboards } = actions;
export default reducer;
